import { fromJS } from 'immutable';
import { isString } from '../../../form/formUtilities';

export const referenceSearchModel = fromJS({
  name: 'referenceSearchForm',
  initialValues: {
    id: '',
    minId: '',
    maxId: '',
    have: '',
    year: '',

    /* EARTHQUAKE SEARCH ---------------------------------------------------- */
    eqAssoc: '',
    eqId: '',
    eqMinId: '',
    eqMaxId: '',
    eqMinYear: '',
    eqMaxYear: '',
    eqRegion: '',
    eqCountry: '',
    eqArea: '',
    eqMinEqMagnitude: '',
    eqMaxEqMagnitude: '',
    eqMinIntensity: '',
    eqMaxIntensity: '',
    eqMinEqDepth: '',
    eqMaxEqDepth: '',
    eqMinDeaths: '',
    eqMaxDeaths: '',
    eqMinDeathsAmountOrder: '',
    eqMaxDeathsAmountOrder: '',
    eqMinDamageMillionsDollars: '',
    eqMaxDamageMillionsDollars: '',
    eqMinDamageAmountOrder: '',
    eqMaxDamageAmountOrder: '',
    eqAssocVol: '',
    eqAssocTsu: '',
    eqMinDeathsTotal: '',
    eqMaxDeathsTotal: '',
    eqMinDeathsAmountOrderTotal: '',
    eqMaxDeathsAmountOrderTotal: '',

    /* VOLCANO SEARCH ------------------------------------------------------- */
    volAssoc: '',
    volId: '',
    volMinId: '',
    volMaxId: '',
    volMinYear: '',
    volMaxYear: '',
    volCountry: '',
    volRegion: '',
    volMinLongitude: '',
    volMaxLongitude: '',
    volMinLatitude: '',
    volMaxLatitude: '',
    volVolcanoNames: '',
    volMorphology: '',
    volMinVei: '',
    volMaxVei: '',
    volMinDeaths: '',
    volMaxDeaths: '',
    volMinDeathsAmountOrder: '',
    volMaxDeathsAmountOrder: '',
    volMinDamageMillionsDollars: '',
    volMaxDamageMillionsDollars: '',
    volMinDamageAmountOrder: '',
    volMaxDamageAmountOrder: '',
    volAssocEq: '',
    volAssocTsu: '',
    volNameMatch: '', // keep, also in labeled select

    /* VOLCANO LOCATION SEARCH ---------------------------------------------- */
    volLocAssoc: '',
    volLocCountry: '',
    volLocRegion: '',
    volLocMorphology: '',
    volLocStatus: '',
    volLocTimeErupt: '',

    /* TSUNAMI SEARCH ------------------------------------------------------- */
    tsuAssoc: '',
    tsuId: '',
    tsuMinId: '',
    tsuMaxId: '',
    tsuMinYear: '',
    tsuMaxYear: '',
    tsuRegionCode: '',
    tsuCountry: '',
    tsuArea: '',
    tsuMinLatitude: '',
    tsuMaxLatitude: '',
    tsuMinLongitude: '',
    tsuMaxLongitude: '',
    tsuMinEventValidity: '',
    tsuMaxEventValidity: '',
    tsuMinCauseCode: '',
    tsuMaxCauseCode: '',
    tsuCauseCode: '',
    tsuMinEqMagnitude: '',
    tsuMaxEqMagnitude: '',
    tsuRunupRegion: '',
    tsuRunupCountry: '',
    tsuRunupArea: '',
    tsuRunupMinDistance: '',
    tsuRunupMaxDistance: '',
    tsuRunupMinTravelTime: '',
    tsuRunupMaxTravelTime: '',
    tsuMinNumRunups: '',
    tsuMaxNumRunups: '',
    tsuMinMaxWaterHeight: '',
    tsuMaxMaxWaterHeight: '',
    tsuMinDeaths: '',
    tsuMaxDeaths: '',
    tsuMinDeathsAmountOrder: '',
    tsuMaxDeathsAmountOrder: '',
    tsuMinInjuries: '',
    tsuMaxInjuries: '',
    tsuMinInjuriesAmountOrder: '',
    tsuMaxInjuriesAmountOrder: '',
    tsuMinDamageMillionsDollars: '',
    tsuMaxDamageMillionsDollars: '',
    tsuMinDamageAmountOrder: '',
    tsuMaxDamageAmountOrder: '',
    tsuMinHousesDestroyed: '',
    tsuMaxHousesDestroyed: '',
    tsuMinHousesDestroyedAmountOrder: '',
    tsuMaxHousesDestroyedAmountOrder: '',
    tsuMinDeathsTotal: '',
    tsuMaxDeathsTotal: '',
    tsuMinDeathsAmountOrderTotal: '',
    tsuMaxDeathsAmountOrderTotal: '',
    tsuMinDamageMillionsDollarsTotal: '',
    tsuMaxDamageMillionsDollarsTotal: '',
    tsuMinDamageAmountOrderTotal: '',
    tsuMaxDamageAmountOrderTotal: '',
    tsuRunupMeasureType: '',
    tsuRunupDoubtful: '',
    tsuRunupMinHeight: '',
    tsuRunupMaxHeight: '',
    tsuRunupMinDeaths: '',
    tsuRunupMaxDeaths: '',
    tsuRunupMinDeathsAmountOrder: '',
    tsuRunupMaxDeathsAmountOrder: '',
    tsuRunupMinInjuries: '',
    tsuRunupMaxInjuries: '',
    tsuRunupMinInjuriesAmountOrder: '',
    tsuRunupMaxInjuriesAmountOrder: '',
    tsuRunupMinDamageMillionsDollars: '',
    tsuRunupMaxDamageMillionsDollars: '',
    tsuRunupMinDamageAmountOrder: '',
    tsuRunupMaxDamageAmountOrder: '',
    tsuRunupMinHousesDestroyed: '',
    tsuRunupMaxHousesDestroyed: '',
    tsuRunupMinHousesDestroyedAmountOrder: '',
    tsuRunupMaxHousesDestroyedAmountOrder: '',
    tsuAssocDeposits: '',
    tsuOceanicTsunami: '',

    /* DEPOSIT SEARCH ------------------------------------------------------- */
    depAssoc: '',
    depId: '',
    depMinId: '',
    depMaxId: '',
    depMinYear: '',
    depMaxYear: '',
    depPublicationType: '',
    depMinGeologicAgeId: '',
    depMaxGeologicAgeId: '',
    depBodyOfWater: '',
    depCountry: '',
    depMinLatitude: '',
    depMaxLatitude: '',
    depMinLongitude: '',
    depMaxLongitude: '',
    depPublicationYear: '', // TODO: add this to the deposit page also

    /* RUNUP SEARCH --------------------------------------------------------- */
    runupAssoc: '',
    runupId: '',
    runupMinId: '',
    runupMaxId: '',
    runupSourceMinYear: '',
    runupSourceMaxYear: '',
    runupSourceRegionCode: '',
    runupSourceCountry: '',
    runupSourceArea: '',
    runupSourceMinEventValidity: '',
    runupSourceMaxEventValidity: '',
    runupSourceMinCauseCode: '',
    runupSourceMaxCauseCode: '',
    runupSourceMinEqMagnitude: '',
    runupSourceMaxEqMagnitude: '',
    runupRegionCode: '',
    runupCountry: '',
    runupArea: '',
    runupRunupCountry: '',
    runupRunupArea: '',
    runupMinDistFromSource: '',
    runupMaxDistFromSource: '',
    runupMinLatitude: '',
    runupMaxLatitude: '',
    runupMinLongitude: '',
    runupMaxLongitude: '',
    runupTypeMeasurementId: '',
    runupMinRunupHt: '',
    runupMaxRunupHt: '',
    runupMinDeaths: '',
    runupMaxDeaths: '',
    runupMinDeathsAmountOrder: '',
    runupMaxDeathsAmountOrder: '',
    runupMinDamageMillionsDollars: '',
    runupMaxDamageMillionsDollars: '',
    runupMinDamageAmountOrder: '',
    runupMaxDamageAmountOrder: '',
    runupMinInjuries: '',
    runupMaxInjuries: '',
    runupMinInjuriesAmountOrder: '',
    runupMaxInjuriesAmountOrder: '',
    runupMinHousesDestroyed: '',
    runupMaxHousesDestroyed: '',
    runupMinHousesDestroyedAmountOrder: '',
    runupMaxHousesDestroyedAmountOrder: '',
    runupMinHousesDamaged: '',
    runupMaxHousesDamaged: '',
    runupMinHousesDamagedAmountOrder: '',
    runupMaxHousesDamagedAmountOrder: '',
    runupMinTravHours: '',
    runupMaxTravHours: '',
    runupDoubtful: '',
    runupMinRunupHoriz: '',
    runupMaxRunupHoriz: '',
    runupMinTroughHt: '',
    runupMaxTroughHt: '',

    radios: {
      citSearchType: 'citInclude',
      cit: '',
      commentsSearchType: 'commentsInclude',
      comments: '',
      authorSearchType: 'authorInclude',
      author: '',

      eqLocationSearchType: 'eqLocInclude',
      eqLoc: '',
      eqCommentsSearchType: 'eqCommentsInclude',
      eqComments: '',

      volLocationSearchType: 'volLocationInclude',
      volLocation: '',
      volNameSearchType: 'volNameInclude',
      volName: '',
      volCommentsSearchType: 'volCommentsInclude',
      volComments: '',

      volLocNameSearchType: 'volLocNameInclude',
      volLocName: '',

      tsuLocationSearchType: 'tsuLocInclude',
      tsuLoc: '',
      tsuCommentsSearchType: 'tsuCommentsInclude',
      tsuComments: '',
      tsuRunupLocationSearchType: 'tsuRunupLocInclude',
      tsuRunupLoc: '',

      depAuthorSearchType: 'depAuthorInclude',
      depAuthor: '',
      depEventSearchType: 'depEventInclude',
      depEvent: '',
      depLocationSearchType: 'depLocInclude',
      depLoc: '',

      runupLocationSearchType: 'runupLocInclude',
      runupLoc: '',
      runupCommentsSearchType: 'runupCommentsInclude',
      runupComments: '',
    },
  },
});


export const toSearchParameters = (model) => {
  const search = model.toJS();
  const {
    radios: {
      citSearchType,
      cit,
      commentsSearchType,
      comments,
      authorSearchType,
      author,

      eqLocationSearchType,
      eqLoc,
      eqCommentsSearchType,
      eqComments,

      volLocationSearchType,
      volLocation,
      volNameSearchType,
      volName,
      volCommentsSearchType,
      volComments,

      volLocNameSearchType,
      volLocName,

      tsuLocationSearchType,
      tsuLoc,
      tsuCommentsSearchType,
      tsuComments,
      tsuRunupLocationSearchType,
      tsuRunupLoc,

      depAuthorSearchType,
      depAuthor,
      depEventSearchType,
      depEvent,
      depLocationSearchType,
      depLoc,

      runupLocationSearchType,
      runupLoc,
      runupCommentsSearchType,
      runupComments,
    },
  } = search;

  if (citSearchType) {
    search[citSearchType] = cit;
  }

  if (commentsSearchType) {
    search[commentsSearchType] = comments;
  }

  if (authorSearchType) {
    search[authorSearchType] = author;
  }

  if (eqLocationSearchType) {
    search[eqLocationSearchType] = eqLoc;
  }

  if (eqCommentsSearchType) {
    search[eqCommentsSearchType] = eqComments;
  }

  if (volLocationSearchType) {
    search[volLocationSearchType] = volLocation;
  }

  if (volNameSearchType) {
    search[volNameSearchType] = volName;
  }

  if (volCommentsSearchType) {
    search[volCommentsSearchType] = volComments;
  }

  if (volLocNameSearchType) {
    search[volLocNameSearchType] = volLocName;
  }

  if (tsuLocationSearchType) {
    search[tsuLocationSearchType] = tsuLoc;
  }

  if (tsuCommentsSearchType) {
    search[tsuCommentsSearchType] = tsuComments;
  }

  if (tsuRunupLocationSearchType) {
    search[tsuRunupLocationSearchType] = tsuRunupLoc;
  }

  if (depAuthorSearchType) {
    search[depAuthorSearchType] = depAuthor;
  }

  if (depEventSearchType) {
    search[depEventSearchType] = depEvent;
  }

  if (depLocationSearchType) {
    search[depLocationSearchType] = depLoc;
  }

  if (runupLocationSearchType) {
    search[runupLocationSearchType] = runupLoc;
  }

  if (runupCommentsSearchType) {
    search[runupCommentsSearchType] = runupComments;
  }

  delete search.radios;


  Object.keys(search).forEach((key) => {
    let value = search[key];
    if (isString(value)) {
      value = value.trim();
      if (value) {
        search[key] = value;
      } else {
        delete search[key];
      }
    }
  });

  return search;
};
